export const LOADING_ARIA_LABEL = 'Loading page content';
export const LOADING_ROLE = 'status';
export const LOADING_ARIA_BUSY = 'true';
export const LOADING_ARIA_LIVE = 'assertive';
